import { ImpulseFormList, ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";

import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { DashboardVariable } from "../../common/dashboard-spec";

export type VariableState = ImpulseFormUnit<DashboardVariable, string>;

export function initVariableState(variable: DashboardVariable): VariableState {
	return ImpulseFormUnit<DashboardVariable, string>(variable, {
		isInputEqual: (left, right) => left.isEqual(right),
	});
}

export type VariablesState = ImpulseFormList<
	ImpulseFormShape<{
		id: string;
		variable: VariableState;
	}>
>;

export function initVariablesState(variables: ReadonlyArray<DashboardVariable>): VariablesState {
	return ImpulseFormList(
		variables.map((variable, index) =>
			ImpulseFormShape({
				id: index.toString(),
				variable: initVariableState(variable),
			}),
		),
	);
}

export interface DrawerState {
	id?: string;
	variables: VariablesState;
	timeRange: TimeRange;
	onSave: (variables: ReadonlyArray<DashboardVariable>) => void;
}
